import React from 'react';
// import cx from 'classnames';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
// import Breadcrumbs from 'desktop/components/Breadcrumbs/Breadcrumbs';
import BreadcrumbsLinks from 'shared/components/BreadcrumbsLinks/BreadcrumbsLinks';

import LeasingHeader from 'shared/components/Article/Leasing/LeasingHeader/LeasingHeader';
// import LeasingBannerInfo from 'shared/components/Article/Leasing/LeasingBannerInfo/LeasingBannerInfo';
import LeasingConditions from 'shared/components/Article/Leasing/LeasingConditions/LeasingConditions';
import LeasingFaq from 'shared/components/Article/Leasing/LeasingFaq/LeasingFaq';
import LeasingFeedbacks from 'shared/components/Article/Leasing/LeasingFeedback/LeasingFeedback';
import LeasingGuaranty from 'shared/components/Article/Leasing/LeasingGuaranty/LeasingGuaranty';
import LeasingHowToPayOff from 'shared/components/Article/Leasing/LeasingHowToPayOff/LeasingHowToPayOff';
// import LeasingMedia from 'shared/components/Article/Leasing/LeasingMedia/LeasingMedia';
import LeasingPartners from 'shared/components/Article/Leasing/LeasingPartners/LeasingPartners';
import LeasingCars from 'shared/components/Article/Leasing/LeasingCars/LeasingCars';
// import LeasingQuestions from 'shared/components/Article/Leasing/LeasingQuestions/LeasingQuestions';
import LeasingWhyAbUa from 'shared/components/Article/Leasing/LeasingWhyAbUa/LeasingWhyAbUa';
import LeasingSpecialPropositions from 'shared/components/Article/Leasing/LeasingSpecialPropositions/LeasingSpecialPropositions';
import LeasingReliablePartner from 'shared/components/Article/Leasing/LeasingReliablePartner/LeasingReliablePartner';
import TitleDivider from 'shared/components/Article/TitleDivider/TitleDivider';

import s from './ArticleLeasing.css';

// TODO: Move to shared component ArticleLeasing.

class ArticleLeasing extends React.Component {
  static propTypes = {
    specialCars: PropTypes.arrayOf(PropTypes.shape()),
    h1: PropTypes.string.isRequired,
    content: PropTypes.string.isRequired,
    breadcrumbsLinks: PropTypes.arrayOf(PropTypes.array),
    searchLink: PropTypes.string,
    categories: PropTypes.arrayOf(PropTypes.string),
    titles: PropTypes.shape(),
  };
  static defaultProps = {
    searchLink: '',
    specialCars: [],
    breadcrumbsLinks: [],
    categories: [],
    titles: {},
  };

  render() {
    const {
      specialCars,
      searchLink,
      content,
      h1,
      breadcrumbsLinks,
      categories,
      titles,
    } = this.props;

    const { specialPropositions, leasingWhy, conditions } = titles;

    return (
      <div className={s.root}>
        <div className={s.breadcrumbs}>
          <BreadcrumbsLinks links={breadcrumbsLinks} />
        </div>

        <div className={s.block}>
          <LeasingHeader />
        </div>
        <div className={s.block}>
          <TitleDivider title={specialPropositions} />
          <LeasingSpecialPropositions specialCars={specialCars} searchLink={searchLink} />
        </div>
        <div className={s.block}>
          <TitleDivider divider={false} title={leasingWhy} />
          <LeasingWhyAbUa />
        </div>

        <div className={s.block}>
          <LeasingConditions title={conditions} />
        </div>

        <div className={s.block}>
          <TitleDivider title="Как погасить авто лизинг?" />
          <LeasingHowToPayOff />
        </div>

        <div className={s.block}>
          <LeasingReliablePartner />
        </div>

        <div className={s.block}>
          <TitleDivider title="Отзывы" />
          <LeasingFeedbacks />
        </div>

        <div className={s.block}>
          <LeasingGuaranty />
        </div>

        <div className={s.block}>
          <TitleDivider position="center" title="Наши партнеры" />
          <LeasingPartners />
        </div>

        <div className={s.block}>
          <TitleDivider title={h1} h1 />
          <LeasingCars content={content} />
        </div>

        {categories.length === 0 &&
          <React.Fragment>
            <TitleDivider title="Частые вопросы" />
            <LeasingFaq />
          </React.Fragment>}
      </div>
    );
  }
}

export default withStyles(s)(ArticleLeasing);



// WEBPACK FOOTER //
// ./src/desktop/routes/articles/ArticleLeasing.js